import React from 'react';
import { Navigate } from 'react-router-dom';
import { path } from '../Utils/ScreenPath';

const PublicRoute = ({ Component, ...rest }) => {
  const token = localStorage.getItem('token');

  return token !== null ? <Navigate to={path?.dashboard} /> : <Component {...rest} />;
};

export default PublicRoute;
